"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Dialog = _interopRequireDefault(require("../dialog/Dialog"));

var _BrowserWarningMessageDE = _interopRequireDefault(require("./BrowserWarningMessageDE"));

var _BrowserWarningMessageEN = _interopRequireDefault(require("./BrowserWarningMessageEN"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var UNSUPPORTED_BROWSER_TAG = 'ua-ie';

var getLanguage = function getLanguage() {
  if (window) {
    return window.navigator.language.toLowerCase();
  }

  return '';
};

var BrowserWarning = function BrowserWarning(props) {
  var show = props.show,
      onClose = props.onClose,
      onBrowserSelect = props.onBrowserSelect;

  var _useState = (0, _react.useState)(show),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showWarning = _useState2[0],
      setShowWarning = _useState2[1];

  var handleClose = function handleClose() {
    setShowWarning(false);
    onClose(false);
  }; // Force to show the dialog from outside


  (0, _react.useEffect)(function () {
    return setShowWarning(show);
  }, [show]); // check HTML tag for browsers only on mount

  (0, _react.useEffect)(function () {
    if (document && document.documentElement && document.documentElement.classList.contains(UNSUPPORTED_BROWSER_TAG)) {
      setShowWarning(true);
    }
  }, []);
  var lang = getLanguage();
  var isDE = lang.startsWith('de');
  var body = isDE ? /*#__PURE__*/_react.default.createElement(_BrowserWarningMessageDE.default, {
    onBrowserSelect: onBrowserSelect
  }) : /*#__PURE__*/_react.default.createElement(_BrowserWarningMessageEN.default, {
    onBrowserSelect: onBrowserSelect
  });
  var footerText = isDE ? 'Weiter im IE11' : 'Continue with IE11';

  var footer = /*#__PURE__*/_react.default.createElement("div", {
    className: 'display-flex justify-content-end'
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: 'button',
    className: 'btn btn-link',
    onClick: handleClose
  }, footerText));

  return /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    show: showWarning,
    className: 'backdrop-blured',
    body: body,
    footer: footer,
    onHide: handleClose
  });
};

BrowserWarning.defaultProps = {
  onClose: function onClose() {},
  onBrowserSelect: function onBrowserSelect() {}
};
BrowserWarning.propTypes = {
  onClose: _propTypes.default.func,
  onBrowserSelect: _propTypes.default.func
};
var _default = BrowserWarning;
exports.default = _default;